export default __webpack_public_path__ + "static/media/Sonnant_Default.16ff0ac4.png";